<template>
  <nav aria-label="Primary navigation" class="navbar navbar-expand-lg navbar-dark" style="background-color:#003865;">
    <div class="container-fluid">
      <div @click="homeByLogo()" class="navbar-brand d-flex flex-wrap">
        <img src="../../assets/logo-reverse.png" alt="Minnesota Department of Health Logo" class="me-4 flex-shrink-0" style="height:38px;"/>
        <div class="text-white fs-4 text-nowrap">{{ appTitle }}</div>
      </div>
      <button v-if="authStore.authenticated && !authStore.loadingProfile" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon "></span>
      </button>
    </div>
    <div class="container-fluid">
      <div class="collapse navbar-collapse vstack gap-2" id="navbarSupportedContent">
        <div class="ms-auto">
          <div
            v-if="authStore.authenticated && authStore.isAdminUser"
            class="d-inline-flex"
          >
            <a
              href="#"
              class="text-white custom-hover-white mx-2"
              id="adminMenuLink"
              role="menuitem"
              aria-haspopup="true"
              aria-expanded="false"
              @click.prevent="toggleAdminMenu"
              @keydown.enter.prevent="toggleAdminMenu"
              @keydown.space.prevent="toggleAdminMenu"
            >
              Admin
              <i class="pi pi-chevron-down ms-1" style="font-size: 0.75rem; line-height: 1;"></i>
            </a>

            <TieredMenu
              ref="adminMenu"
              :model="adminMenuItems"
              popup
              :aria-labelledby="'adminMenuLink'"
            />
          </div>

          <div v-if="authStore.authenticated && !authStore.loadingProfile" class="d-inline-flex">
            <a href="#"
               id="userMenuLink"
               class="text-white custom-hover-white mx-2"
               aria-haspopup="true"
               aria-expanded="false"
               @click.prevent="toggleUserMenu"
               @keydown.enter.prevent="toggleUserMenu"
               @keydown.space.prevent="toggleUserMenu">
              {{ authStore.user?.username }}
              <i class="pi pi-chevron-down ms-1" style="font-size: 0.75rem; line-height: 1;"></i>
            </a>

            <TieredMenu ref="userMenu"
                        :model="userMenuItems"
                        popup
                        :aria-labelledby="'userMenuLink'" />
          </div>
        </div>
      </div>
    </div>
  </nav>
  <Popover ref="op">
    <div class="p-3 d-flex">
      <div class="me-4">
        <Avatar :label="authStore.user?.initials" size="large" shape="circle" />
      </div>
      <div>
        {{ authStore.user?.firstName }} {{ authStore.user?.lastName }}
        <br />
        <small>{{ authStore.user?.primaryOrganizationName }}</small>
      </div>
    </div>
  </Popover>
</template>

<script setup>
import {useAuthStore} from '@/stores/authStore';
import Popover from 'primevue/popover';
import Avatar from 'primevue/avatar';
import TieredMenu from 'primevue/tieredmenu';
import {computed, ref} from 'vue';
import router from "@/router/index.js";
import keycloakService from "@/services/keycloakService.js";

const op = ref();

const authStore = useAuthStore();
const appTitle = import.meta.env.VITE_APP_TITLE;

async function logout() {
  await keycloakService.CallLogout();
  authStore.authenticated = false;
}

function homeByLogo(){
  if(authStore.authenticated){
    router.push({ path: '/MainLandingPage' });
  } else {
    router.push({ path: '/' });
  }
}

// Admin Menu
const adminMenu = ref(null);
function toggleAdminMenu(event) {
  adminMenu.value.toggle(event);
}

const adminMenuItems = computed(() => {
  const routes = router.getRoutes().filter(r => r.path.startsWith('/Admin') && r.path !== '/Admin');
  return routes.map(r => ({
    label: r.meta?.title || r.name || r.path,
    command: () => router.push(r.path)
  }));
});

// User Menu
const userMenu = ref(null);
function toggleUserMenu(event) {
  userMenu.value.toggle(event);
}

const userMenuItems = [
  {
    label: 'Manage Account',
    icon: 'pi pi-user-edit',
    command: () => router.push('/ManageAccount'),
  },
  { separator: true },
  {
    label: 'Sign Out',
    icon: 'pi pi-sign-out',
    command: () => logout(),
  }
];
</script>

<style>
.navbar-brand {
  cursor: pointer;
}
.custom-hover-white:hover {
  color: white !important;
}
</style>